import { GenericService } from './generic.service';
export class ExternalIdentifierTypeService extends GenericService {
    constructor() {
        super('v1/external-identifier-types');
    }
}
